<template>
  <div>
    <div id="graph" />
  </div>
</template>

<script>
import { getGraphs } from "@/api/app.js";

export default {
  computed: {
    graph() {
      return this.$store.state.graph;
    }
  },
  watch: {
    "$store.state.searchSubmitted": async function() {
      const searchSubmitted = this.$store.state.searchSubmitted;

      if (!searchSubmitted) return;

      const depth = this.$store.state.depth;
      const input = this.$store.state.input;

      const graph = await getGraphs({
        curso: "ciencia-da-computacao",
        termo: input,
        profundidade: depth
      });

      this.$store.commit("changeGraph", graph);
      this.$store.dispatch("searchDone");
    }
  },
  async mounted() {
    const graph = await getGraphs({
      curso: "ciencia-da-computacao",
      termo: "grafo",
      profundidade: "2"
    });

    this.$store.commit("changeGraph", graph);
  }
};
</script>

<style>
canvas {
  overflow: hidden;
}
</style>
